<div class="header">
  <h1 class="title">TDM Studio Visualizations Documentation</h1>
  <div class="close_div"
      tabindex="0"
      role="button"
      aria-label="Close dialog"
      (click)="dialogRef.close()" 
      (keyup.enter)="dialogRef.close()">
    <i class="bi bi-x"></i>
  </div>
</div>

<div class="tab_bar" fxLayout="row" fxLayoutAlign="space-around center">
  <ng-template ngFor let-docTab [ngForOf]="docTabs">
    <p 
      [ngClass]="selected === docTab ? 'current tab' : 'tab'"
      role="tab"
      (click)="selected = docTab"
      (keyup.enter)="selected = docTab"
      tabindex="0"
      #tabBtn>{{ docTab }}</p>
  </ng-template>
</div>

<mat-dialog-content>
  <div class="content_conatiner">
    <tdms-viz-dashboard-doc-tab *ngIf="selected === 'Visualization Dashboard'"></tdms-viz-dashboard-doc-tab>
    <tdms-create-project-doc-tab *ngIf="selected === 'Create a Project'"></tdms-create-project-doc-tab>
    <tdms-geo-analysis-doc-tab *ngIf="selected === 'Geographic Analysis'"></tdms-geo-analysis-doc-tab>
    <tdms-topic-modeling-doc-tab *ngIf="selected === 'Topic Modeling'"></tdms-topic-modeling-doc-tab>
    <tdms-sa-doc-tab *ngIf="selected === 'Sentiment Analysis'"></tdms-sa-doc-tab>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="dialog-actions">
    <div class="button" tabindex="0" (click)="dialogRef.close()" (keyup.enter)="dialogRef.close()">Close</div>
  </div>
</mat-dialog-actions>
